import React, { useEffect, useState } from 'react';
import {
    Button,
    Col,
    FormControl,
    InputGroup,
    Modal,
    Row,
    ListGroup
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { addExpenseType, removeExpenseType, editExpenseType } from '../../redux/actions'
import { request, EXPENSE_REQUEST } from '../../redux/actions/utilities';
import { ErrorMessage } from './ErrorMessage';
import { deleteAlertDialog } from '../genericAction';
export function AddOptionsModal(props) {
    const expenses = useSelector((state) => state.expenses);
    const dispatch = useDispatch();
    const [newOptionVal, setNewOptionVal] = useState(null);
    const [editOptionVal, setEditOptionVal] = useState(null);
    const closeOptionsModal = () => {
        props.optionClose();
    };
    const AddNewExpenseType = () => {
        if (newOptionVal !== null) {
            dispatch(addExpenseType({
                "expenseTypeId": 0,
                "expense": newOptionVal,
                "description": ""
            }, props.optionClose))
            setNewOptionVal(null);
            setEditOptionVal(null);
        }
        closeOptionsModal();
    }
    const deleteExpenseType = (expenseId) => {
        dispatch(removeExpenseType(expenseId))
        setNewOptionVal(null);
        setEditOptionVal(null);
    }
    const toEditExpenseType = (expenseTypeData) => {
        if (editOptionVal !== null) {
            dispatch(editExpenseType({
                expenseTypeId: expenseTypeData.expenseTypeId, expense: editOptionVal, description: expenseTypeData.description
            }))
            setNewOptionVal(null);
            setEditOptionVal(null);
        }
    }
    useEffect(() => {
        setNewOptionVal(null);
        setEditOptionVal(null);
        dispatch(request(EXPENSE_REQUEST.ADD_EXPENSE_RESET));
    }, [])
    return (
        <Modal id="add-edit-expense" centered size="lg" show={props.optionsModal} onHide={props.optionClose}>
            <Modal.Header closeButton>
                <Modal.Title className="text-uppercase font-weight-light">
                    {"Add New Expense Type"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xs={12}>
                        <label className="font-weight-bold">{"Enter New Option"}</label>
                        <InputGroup className="mb-3">
                            <FormControl
                                placeholder="Enter New Option"
                                aria-label="Default"
                                aria-describedby="inputGroup-sizing-default"
                                name="newOptionVal"
                                onChange={(e) => setNewOptionVal(e.target.value)}
                            />
                        </InputGroup>
                    </Col>
                </Row>
                <hr />
                <label className="font-weight-bold">{"Existing Types:"}</label>
                {
                    expenses
                    &&
                    expenses.addExpenseTypeFailure === true
                    &&
                    expenses.addExpenseTypeError
                    &&
                    <ErrorMessage message={expenses.addExpenseTypeError} />
                }
                <div className="item-list-to-show">
                    {
                        expenses
                        &&
                        expenses.expenseTypes
                        &&
                        expenses.expenseTypes.map((option, index) => {
                            return (
                                <DisplayOption
                                    key={index}
                                    deleteExpenseType={deleteExpenseType}
                                    toEditExpenseType={toEditExpenseType}
                                    option={option}
                                    setEditOptionVal={setEditOptionVal} />
                            )
                        })}
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button size="sm" variant="secondary"
                    disabled={expenses.addExpenseTypeLoading} onClick={closeOptionsModal}>
                    {"Close"}
                </Button>
                <Button
                    className="py-1 px-2 rounded"
                    bsPrefix="vc-generic-btn"
                    size="sm"
                    variant="primary"
                    disabled={expenses.addExpenseTypeLoading}
                    onClick={() => {
                        AddNewExpenseType()
                    }}>
                    {"Save"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export function DisplayOption(props) {
    const [isEdit, setIsEdit] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(request(EXPENSE_REQUEST.ADD_EXPENSE_RESET));
    }, [])
    return (
        <>
            {
                isEdit ? (
                    <InputGroup key={props.option.expenseTypeId} className="mb-2">
                        <FormControl
                            defaultValue={props.option.expense}
                            aria-label="Default"
                            aria-describedby="inputGroup-sizing-default"
                            onChange={(e) => props.setEditOptionVal(e.target.value)}
                        />

                        <InputGroup.Append>
                            <Button
                                variant="outline-primary"
                                onClick={() => {
                                    props.toEditExpenseType(props.option);
                                    setIsEdit(false);
                                }}>
                                {"Ok"}
                            </Button>
                        </InputGroup.Append>
                    </InputGroup>
                ) : (
                    <ListGroup className="mb-1">
                        <ListGroup.Item className="d-flex justify-content-between">
                            <div>{props.option.expense}</div>
                            <div>
                                <FontAwesomeIcon className="expense-type-icon" onClick={() => setIsEdit(true)} icon={faEdit} />
                                <FontAwesomeIcon className="expense-type-icon" onClick={() => { deleteAlertDialog(props.deleteExpenseType, props.option.expenseTypeId) }} icon={faTrash} />
                            </div>
                        </ListGroup.Item>
                    </ListGroup>

                )
            }
        </>
    );
}
